import { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useHistory, useRouteMatch } from "react-router-dom";
import Map from "./../Map";

const useStyles = makeStyles((theme) => ({
  // root: {
  //   flexGrow: 1,
  //   color: theme.palette.text.secondary,
  // },
  // paper: {
  //   padding: theme.spacing(2),
  //   textAlign: 'center',
  //   color: theme.palette.text.secondary,
  // },
}));

const Dashboard = ({
  equipmentWeight,
  noOfAlarms,
  levelInformation,
  mapData,
  currentOrganisation,
  unClearedAlarms,
  setSelectedColor,
  selectedColor,
}) => {
  useEffect(async () => {
    if (currentOrganisation === "ntuGomic") {
      history.push("/dashboard/equipment");
    }
  });
  const classes = useStyles();
  let history = useHistory();
  const { path } = useRouteMatch();
  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid item xs={6} sm={6}>
          <Paper style={{ textAlign: "center", fontSize: "1.2em" }}>
            <Typography component="p">Uncleared Alarms :</Typography>
            <span
              onClick={() => {
                if (noOfAlarms > 0) {
                  history.push(`${path}/alarms`);
                }
              }}
              style={
                noOfAlarms < 1
                  ? { fontSize: "3em" }
                  : {
                      fontSize: "3em",
                      cursor: "pointer",
                      color: "red",
                      textDecoration: "underline",
                    }
              }
              component="p"
            >
              {noOfAlarms}
            </span>
          </Paper>
        </Grid>
        <Grid item xs={6} sm={6}>
          <Paper style={{ textAlign: "center", fontSize: "1.2em" }}>
            <Typography component="p">Total Weight (kg) :</Typography>
            <Typography
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push(`${path}/equipment`);
              }}
              style={{ fontSize: "3em", cursor: "pointer" }}
              component="p"
            >
              {equipmentWeight}
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Map
              mapData={mapData}
              levelInformation={levelInformation}
              currentOrganisation={currentOrganisation}
              unClearedAlarms={unClearedAlarms}
              setSelectedColor={setSelectedColor}
              selectedColor={selectedColor}
            />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
